<template>
	<div class="vforms-input">
		<input
			v-model.trim="inputValue"
			:name="id"
			:id="id"
			:type="type"
			:autocomplete="autocomplete"
			:placeholder="placeholder"
			:class="inputClassListLive"
			:readonly="readonlyLive"
			:required="requiredLive"
			:disabled="disabledLive"
			:title="inputValue"

			@change="onChangeHandler"
			@input="onInputHandler"
			@focus="onFocusHandler"
			@blur="onBlurHandler"
		>
		<button class="vforms-btn" v-if="showCopyToClipboard" @click.prevent="copyToClipboard">{{ $t('vforms.copy_to_clipboard') }}</button>
	</div>
</template>

<script>
import {baseInput} from './../mixins/index.js';

export default {
	name: 'TextInput',
	props: {
		type: {type: String, required: false, default: 'text'},
		showCopyToClipboard: {type: Boolean, required: false, default: false}
	},
	mixins: [
		baseInput
	],
	methods: {
		copyToClipboard() {
			navigator.clipboard.writeText(this.inputValue);
		}
	}
};
</script>
